// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  firebase: {
    apiKey: "***************************************",
    authDomain: "************************",
    projectId: "***********************************",
    storageBucket: "************************",
    messagingSenderId: "*********************",
    appId: "*******************************************",
    measurementId: "*********************"
  },
  baseUrl: 'https://dev-organiser-api-entrypasses.videostech.cloud/',
  //  baseUrl: 'https://dev-organiser-api.livepass.in/',
  //  baseUrl:"https://staging-organiser-api.livepass.in/",
   apiToken: 'a22c1104b79a4e7e6082568b3c004e7a50fbb803b0b7097386648ae762058e89',
   appUrl:'https://dev-entrypasses.videostech.cloud'
};
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
